// https://www.w3schools.com/JS/js_cookies.asp
// sets a cookie at root path
function setCookie(cname, cvalue, exmin) {
  var d = new Date();
  d.setTime(d.getTime() + (exmin * 60 * 1000));
  var expires = 'expires='+d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

// gets cookie value
function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

// checks if a cookie exists
function checkCookie(cname) {
  var cookieValue = getCookie(cname);
  if(!cookieValue) return false;
  return true;
}

// deletes a cookie
var deleteCookie = function(cname) {
  document.cookie = cname +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export {
  setCookie,
  getCookie,
  checkCookie,
  deleteCookie
};
